import { MaterialTopTabNavigationOptions } from "expo-router/js-top-tabs";

interface underlineTopTabOptionsProps {
  width: number;
  tabQty?: number;
}

export const underlineTopTabOptions = ({
  width,
  tabQty = 2
}: underlineTopTabOptionsProps): MaterialTopTabNavigationOptions => {
  let marginHorizontal = 0;

  if (width >= 768 && width < 1024) {
    marginHorizontal = tabQty === 2 ? width * 0.25 : width * 0.225;
  } else if (width >= 1024 && width <= 1440) {
    marginHorizontal = tabQty === 2 ? width * 0.225 : width * 0.15;
  } else if (width >= 1440 && width <= 2560) {
    marginHorizontal = tabQty === 2 ? width * 0.15 : width * 0.1;
  } else if (width > 2560 && width <= 3280) {
    marginHorizontal = tabQty === 2 ? width * 0.125 : width * 0.085;
  } else if (width > 3280) {
    marginHorizontal = tabQty === 2 ? width * 0.1 : width * 0.005;
  } else if (width <= 375) {
    marginHorizontal = tabQty === 2 ? width * 0.075 : width * 0.05;
  } else {
    /// Mobile Default
    marginHorizontal = tabQty === 2 ? width * 0.204 : width * 0.12;
  }

  return {
    swipeEnabled: false,
    tabBarScrollEnabled: false,

    tabBarStyle: {
      shadowColor: 'transparent',
      marginHorizontal: marginHorizontal
    },

    tabBarIndicatorStyle: {
      bottom: 8,
      backgroundColor: 'black',
      height: 2
    },

    tabBarLabelStyle: {
      textTransform: 'capitalize',
      fontWeight: '700',
      fontSize: 18,
      color: 'black',
      width: '100%'
    },

    tabBarAllowFontScaling: false
  };
};

// Auth
export const SIGN_IN_BUTTON_BOTTOM = 60;

export const BLUR_HASH = 'LHATft%MWBWB~q%MM{WBxu%MM{WB';

//Distances
export const MINIMUM_DISTANCE = 10;
export const MAXIMUM_DISTANCE = 300;
